import * as PIXI from "pixi.js";
//@ts-ignore
window.PIXI = PIXI;
import "pixi-spine";
import "pixi.js-legacy";
import "lodash";
import "gsap";
import * as fakeResponseCheats from "../../cheatFiles/fakeResponseCheats.json";
import GameModel from "../../vendor_core/core/src/model/GameModel";
import { HasRealityCheckCondition, ForceRealityCheckCondition} from "../../vendor_core/core/src/states/conditions/RealityCheckConditions";
import VendorRealityCheckState from "../../vendor_core/src/states/VendorRealityCheckState";
import VendorFinishState from "../../vendor_core/src/states/VendorFinishState";
import AlwaysTrueCondition from "../../vendor_core/core/src/states/conditions/AlwaysTrueCondition";
import AwardedFreeGamesCondition from "../../vendor_core/src/states/conditions/AwardedFreeGamesCondition";
import HasFreeGamesExpiredCondition from "../../vendor_core/src/states/conditions/HasFreeGamesExpiredCondition"
import FreeGamesAwardedState from "../../vendor_core/src/states/FreeGamesAwardedState";
import ShouldExitFreeGamesCondition from '../../vendor_core/src/states/conditions/ShouldExitFreeGamesCondition';
import ExitFreeGamesState from '../../vendor_core/src/states/ExitFreeGamesState';
import HasRandomSymbolsCondition from "../../vendor_core/core/src/states/conditions/HasRandomSymbolsCondition";
import CombinedCondition, { ConditionCombinationType } from "../../vendor_core/core/src/states/conditions/CombinedCondition";
import { VOEHasBigWinCondition } from './states/conditions/VOEHasBigWinCondition';
import VOEFreeSpinsWonCondition from "../src/states/conditions/VOEFreeSpinsWonCondition";
import { HasAutoplayCondition } from "../../vendor_core/core/src/states/conditions/HasAutoplayCondition";
import { HasFreeSpinsCondition } from "../../vendor_core/core/src/states/conditions/HasFreeSpinsCondition";
import { IsInFreeSpinsCondition } from "../../vendor_core/core/src/states/conditions/IsInFreeSpinsCondition";
import HTMLPopupsManager from "../../vendor_core/core/src/utils/HTMLPopupsManager";
import HistoryHTMLPopup from "../../vendor_core/src/ui/popups/HistoryHTMLPopup";
import App from "../../vendor_core/core/src/App";
import InstanceFactory from "../../vendor_core/core/src/factories/InstanceFactory";
import Assets from "../../vendor_core/core/src/utils/Assets";
import GameLoader from "../../vendor_core/core/src/utils/GameLoader";
import Layout from "../../vendor_core/core/src/utils/Layout";
import SoundController from "../../vendor_core/core/src/utils/SoundController";
import SymbolMap from "../../vendor_core/core/src/utils/SymbolMap";
import VOEGameFactory from "./VOEGameFactory";
import GameFactory from "./VOEGameFactory";
import Utils from "../../vendor_core/core/src/utils/Utils";
import * as asset_config from "../configs/asset-config-main.json";
import * as debug_config from "../configs/debug-config.json";
import * as game_config from "../configs/game-config.json";
import * as state_config from "../configs/state-config.json";
import ViewManager from "../../vendor_core/core/src/utils/ViewManager";
import requestRegister from "../../vendor_core/core/src/server/requests/RequestRegister";
import stateMachine from "../../vendor_core/core/src/states/StateMachine";
import VOESpinEndState from "./states/VOESpinEndState";
import LoopLinesState from "../../vendor_core/core/src/states/LoopLinesState";
import { IStatesConfigSchema } from "../../vendor_core/core/src/states/State";
import BetModel from "../../vendor_core/core/src/model/BetModel";
import SpinModel from "../../vendor_core/core/src/model/SpinModel";
import DebugMenu from "../../vendor_core/core/src/utils/DebugMenu";
import CommManager from "../../vendor_core/core/src/controllers/CommManager";
import ErrorModel from "../../vendor_core/core/src/model/ErrorModel";
import ErrorDataParser from "../../vendor_core/src/server/parsers/errorDataParser";
import ErrorState from "../../vendor_core/src/states/ErrorState";
import MessagePopup from "../../vendor_core/core/src/ui/popups/MessagePopup";
import BuyBonusPopups from "./ui/popups/BuyBonusPopups";
import BuyFeatureSpinPopups from "./ui/popups/BuyFeatureSpinPopup";
import BuyFeatureConfig from '../configs/BuyFeatureConfig';
import AutoplayPopup from "../../vendor_core/src/base/ui/AutoplayPopup";
import VendorAutoplayLimitPopup from "../../vendor_core/src/ui/popups/VendorAutoplayLimitPopup";
import VendorErrorPopup from "../../vendor_core/src/ui/popups/VendorErrorPopup";
import BetPopup from "../../vendor_core/src/base/ui/BetPopup";
import ErrorPopup from "../../vendor_core/core/src/ui/popups/ErrorPopup";
import { HasErrorCondition } from "../../vendor_core/core/src/states/conditions/HasErrorCondition";
import { HasExpandCondition } from "../../vendor_core/core/src/states/conditions/HasExpandCondition";
import UIController from "../../vendor_core/core/src/ui/UIController";
import RealityCheckModel from "../../vendor_core/core/src/model/RealityCheckModel";
import RealityCheckDataParser from "../../vendor_core/src/server/parsers/RealityCheckDataParser";
import BetDataParser from "../../vendor_core/src/server/parsers/BetDataParser";
import VendorModel from "../../vendor_core/src/model/VendorModel";
import VendorDataParser from "../../vendor_core/src/server/parsers/VendorDataParser";
import { Commands } from "../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../vendor_core/core/src/commands/CommandManager";
import * as GameCommands from "../../vendor_core/core/src/commands/GameCommands";
import * as VendorCommands from "../../vendor_core/src/commands/VendorCommands";
import * as MYSGameCommands from "./ui/commands/MYSGameCommands";
import {VendorCommandsEnum} from "../../vendor_core/src/commands/VendorCommandsEnum";
import AutoplayModel from "../../vendor_core/core/src/model/AutoplayModel";
import SaSIdleState from "../src/states/SaSIdleState";
import VOESpinStartState from "./states/VOESpinStartState";

import VOEPreloaderState from "./states/VOEPreloaderState";
import { VOEHasWinCondition } from "./states/conditions/VOEHasWinCondition";
import MYSEnterFreespinsState from "./states/MYSEnterFreespinsState";
import MSFinishState from "./states/MSFinishState";
import MSSpinResultState from "./states/MSSpinResultState";
import OkFStartFSState from "./states/VOEStartFSState";
import SaSExitFreespinsState from "./states/SaSExitFreespinsState";
import PromotionalFreeGamesModel from "../../vendor_core/src/model/PromotionalFreeGamesModel";
import EnterRecoverState from "../../vendor_core/src/states/EnterRecoverState";
import HasRecovery from "../../vendor_core/src/states/conditions/HasRecovery";
import RecoverSpinStartState from "../../vendor_core/src/states/RecoverSpinStartState";
import VOEBigWinState from './states/VOEBigWinState';
import VOEShowWinState from './states/VOEShowWinState';
import FullscreenUtils from "../../vendor_core/core/src/utils/FullscreenUtils";
///import RefreshReelDataParser from "../../vendor_core/src/server/parsers/RefreshReelDataParser";
import { SaSPlayAnimatedExpandState } from "./states/SaSPlayAnimatedExpandState";


//--------Fantasma prototype-------
import GameDataParser from "../../vendor_core/src/server/parsers/GameDataParser";
import SessionDataParser from "../../vendor_core/src/server/parsers/SessionDataParser";
import BalanceDataParser from "../../vendor_core/src/server/parsers/BalanceDataParser";
import AutoplayDataParser from "../../vendor_core/src/server/parsers/AutoplayDataParser";
import SaSSpinDataParser from "./server/parsers/SaSSpinDataParser";
//---------------------------------

import SpinDataParser from "../../vendor_core/src/server/parsers/SpinDataParser";

import LoginDataParser from "../../vendor_core/src/server/parsers/LoginDataParser";
import VOEConfigDataParser from "../src/server/parsers/VOEConfigDataParser";
import TokenDataParser from "../../vendor_core/src/server/parsers/TokenDataParser";
import LockSymbolState from "../../vendor_core/core/src/states/LockSymbolState";
import HasLockedCondition from "../../vendor_core/core/src/states/conditions/HasLockedCondition";

import ClientConfigRequest from "../../vendor_core/src/server/requests/ClientConfigRequest";
import ClientConfigURLRequest from "../../vendor_core/src/server/requests/ClientConfigURLRequest";
import TokenRequest from "../../vendor_core/src/server/requests/TokenRequest";
import LoginRequest from "../../vendor_core/src/server/requests/LoginRequest";
import FunLoginRequest from "../../vendor_core/src/server/requests/FunLoginRequest";
import GetBalanceRequest from "../../vendor_core/src/server/requests/GetBalanceRequest";
import SpinRequest from "../../vendor_core/src/server/requests/SpinRequest";
import FinishRoundRequest from "../../vendor_core/src/server/requests/FinishRoundRequest";
import FreeSpinRequest from "../../vendor_core/src/server/requests/FreeSpinRequest";
import PingRequest from "../../vendor_core/src/server/requests/PingRequest";
import VendorReplayRequest from "../../vendor_core/src/server/requests/VendorReplayRequest";
import HasFreeGamesRequest from "../../vendor_core/src/server/requests/HasFreeGamesRequest";
import CancelFreeGamesRequest from "../../vendor_core/src/server/requests/CancelFreeGamesRequest";
import SkipFreeGamesRequest from "../../vendor_core/src/server/requests/SkipFreeGamesRequest";
import SaveSettingsRequest from "../../vendor_core/src/server/requests/SaveSettingsRequest";
import SaveRestoreStateRequest from "../../vendor_core/src/server/requests/SaveRestoreStateRequest";
import GetSessionRequest from "../../vendor_core/src/server/requests/GetSessionRequest";
import SetRealityCheckLimits from "../../vendor_core/src/server/requests/SetRealityCheckLimits";
import ResetRealityCheck from "../../vendor_core/src/server/requests/ResetRealityCheck";

import VendorSpinResultState from "../../vendor_core/src/states/VendorSpinResultState";
import  VendorWrapper from "../../vendor_core/src/controllers/VendorWrapper";
import FeimCommands from '../../vendor_core/src/commands/FeimCommands';
import ConfigManager from '../../vendor_core/core/src/managers/ConfigManager';
import SettingsConfig from '../configs/SettingConfig';
import BetConfig from '../configs/BetConfig';
import GameLocalConfig from '../configs/GameLocalConfig';
import GameGeneralConfig from '../configs/GameGeneralConfig';
import ErrorConfig from '../configs/ErrorConfig';
import SymbolSpineAnimationConfig from '../configs/SymbolSpineAnimationsConfig';
import SpineAnimationsConfig from '../configs/SpineAnimationsConfig';
import SpineWinSymbolViewConfig from '../configs/SpineWinSymbolViewConfig';
import VendorServerConfig from '../configs/VendorServerConfig';
import ComponentsConfig from '../configs/ComponentsConfig';
import ReelsConfig from '../configs/ReelsConfig';

import './styles/game.css';
import '../../vendor_core/core/static/styles/main.css';
import { utils as PixiUtils } from 'pixi.js';
import EventEmitter = PixiUtils.EventEmitter;
import ConsoleUtil from "../../vendor_core/core/src/utils/ConsoleUtil";

// TODO - move this to some class
const urlParams: any = {};
// test.doSomething();
declare const DEBUG: boolean;
// window.PIXI = PIXI;
location.search
    .substr(1)
    .split("&")
    .forEach((item) => {
        const tmp = item.split("=");
        if (tmp[0].length > 0) {
            urlParams[tmp[0]] = decodeURIComponent(tmp[1]);
        }
    });
ConsoleUtil.log("version : ", urlParams.version);

const link = document.createElement("link");

link.rel = "stylesheet";
link.href = "./styles/main.css?version=" + urlParams.version;
document.getElementsByTagName("head")[0].appendChild(link);
// TODO THIS NEEDS A LOT OF REFACTORING
const start = (params) => {
    // let gameLoader = new GameLoader(urlParams);
    const gameConfig = params.config;
    // GameLoader.loader.baseUrl = "";
    ConfigManager.setDeprecateConfig(gameConfig)
    ConfigManager.registerConfigs([
        SymbolSpineAnimationConfig,
        SpineWinSymbolViewConfig,
        SpineAnimationsConfig,
        SettingsConfig,
        BuyFeatureConfig,
        BetConfig,
        GameLocalConfig,
        GameGeneralConfig,
        ErrorConfig,
        VendorServerConfig,
        ComponentsConfig,
        ReelsConfig
    ])

    GameModel.parseUrlParams(urlParams, gameConfig);

    GameModel.hasRealityCheck = false;
    GameLoader.loadFonts(gameConfig);
    // GameModel.apiConfig = loader.resources.apiConfig.data;
    // wait for fonts to load
    // window.onload = () => {
    const configs = GameModel.isMobile()
        ? asset_config.asset_configs.mobile
        : asset_config.asset_configs.desktop;
    GameLoader.loadConfig(configs, (loader) => {
        GameModel.apiConfig = loader.resources.apiConfig.data;
        GameLoader.loadConfig(
            loader.resources.asset_config.data.layoutConfigurations,
            (loader) => {
                const deviceWidth = Math.max(
                    window.screen.width,
                    window.screen.height
                );
                const START_WIDTH = Math.min(
                    deviceWidth,
                    loader.resources.layoutConfig.data.settings.nativeWidth
                );
                // const START_HEIGHT = loader.resources.layoutConfig.data.settings.nativeHeight;
                //  const START_WIDTH = Math.max(window.screen.width, window.screen.height);
                const START_HEIGHT = (START_WIDTH * 9) / 16;
                ConsoleUtil.log(START_WIDTH, START_HEIGHT);
                CommManager.setComm();
                CommManager.startPing(GameModel.gameConfig.pingDelay);
                initDefaultCommads();
                registerRequests();
                registerParsers();
                GameModel.update(urlParams);
                InstanceFactory.init(new VOEGameFactory());
                HTMLPopupsManager.init(document.getElementById("content"), HistoryHTMLPopup);
                const app = new App(
                    loader.resources.layoutConfig.data.settings
                );
                Layout.init(START_WIDTH, START_HEIGHT);
                Utils.serialize(gameConfig, GameModel);
                SymbolMap.init(GameModel.gameConfig.symbolResponseMap);
                SoundController.init();
                App.version = urlParams.version;
                // Layout.init(START_WIDTH, START_HEIGHT);
                App.assets = new Assets();
                App.utils = new Utils();
                App.dispatcher = new EventEmitter();

                 window["ViewManager"] = ViewManager;
                 window["App"] = App;
                 window["Layout"] = Layout;
                 window["UI"] = UIController;
                // ViewManager.init(layout_config, layerMap);
                const mainLayoutData = loader.resources.layoutConfig.data;
                const secondaryData = loader.resources.secondaryLayoutConfig
                    ? loader.resources.secondaryLayoutConfig.data
                    : null;
                ViewManager.init(
                    mainLayoutData,
                    loader.resources.layerMap.data,
                    secondaryData
                );
                VendorWrapper.init(START_WIDTH, START_HEIGHT);
                window.onresize =  VendorWrapper.onResize.bind(VendorWrapper);
                document
                    .getElementById(params.config.container_name)
                    .appendChild(app.view);
                VendorWrapper.onResize();
                registerStates();
                setUpUIComponents();
                if (DEBUG) {
                    createDebugMenu();
                }

                CommandManager.execute(VendorCommandsEnum.INITIALIZE_API);

                function registerRequests() {
                    requestRegister.add("getclientconfigURL", new ClientConfigURLRequest());
                    requestRegister.add("getclientconfig", new ClientConfigRequest());
                    requestRegister.add("tokenRequest", new TokenRequest());
                    requestRegister.add("loginRequest", new LoginRequest());
                    requestRegister.add("funLoginRequest", new FunLoginRequest());
                    requestRegister.add("getBalance", new GetBalanceRequest());
                    requestRegister.add("spinRequest", new SpinRequest());
                    requestRegister.add("finishRound", new FinishRoundRequest());
                    requestRegister.add("freeSpinRequest", new FreeSpinRequest());
                    requestRegister.add("pingRequest", new PingRequest());
                    requestRegister.add("hasFreeGames", new HasFreeGamesRequest());
                    requestRegister.add("cancelFreeGames", new CancelFreeGamesRequest());
                    requestRegister.add("skipFreeGames", new SkipFreeGamesRequest());
                    requestRegister.add("setRealityCheckLimits", new SetRealityCheckLimits());
                    requestRegister.add("resetRealityCheck", new ResetRealityCheck());
                    requestRegister.add("historyRequest", new VendorReplayRequest());

                    requestRegister.add("saveSettingsRequest", new SaveSettingsRequest());
                    requestRegister.add("saveRestoreState", new SaveRestoreStateRequest());
                    requestRegister.add("sessionResult", new GetSessionRequest());

                }

                function registerParsers() {
                    SpinModel.registerParser(new SaSSpinDataParser());

                    const loginDataParser = new LoginDataParser();
                    GameModel.registerParser(new VOEConfigDataParser());
                    GameModel.registerParser(new TokenDataParser());
                    GameModel.registerParser(loginDataParser);
                    BetModel.registerParser(loginDataParser);
                    RealityCheckModel.registerParser( new RealityCheckDataParser());
                    BetModel.registerParser(new BetDataParser());
                    VendorModel.registerParser(new VendorDataParser());
                    ErrorModel.registerParser(new ErrorDataParser());


                    //-----Fantasma prototype-------
                    GameModel.registerParser(new GameDataParser());
                    GameModel.registerParser(new SessionDataParser());
                    BetModel.registerParser(new BalanceDataParser());
                    AutoplayModel.registerParser(new AutoplayDataParser());
                    //------------------------------
                }

                function createDebugMenu() {
                    const debugMenu = new DebugMenu(
                        document.getElementById("content")
                    );
                    debugMenu.addDebugInput("Custom");
                    Object.keys(debug_config).forEach((key) => {
                        const element = debug_config[key];
                        if ('name' in element && 'data' in element) {
                            debugMenu.addDebugCase(
                                element.name,
                                element.data,
                                false
                            );
                        }
                    });

                    Object.keys(fakeResponseCheats).forEach((key) => {
                        const element = fakeResponseCheats[key];
                        if ('name' in element && 'response' in element) {
                            debugMenu.addFakeResponseDebugCase(
                                element.name,
                                element.response
                            );
                        }
                    });

                    debugMenu.menu.style.zIndex =
                        params.config.canvas_zIndex + 1;
                }

                function registerStates() {
                    stateMachine.registerState(
                        "preload",
                        new VOEPreloaderState(stateMachine)
                    );
                    stateMachine.registerState(
                        "idle",
                        new SaSIdleState(stateMachine)
                    );
                    stateMachine.registerState(
                        "spin",
                        new VOESpinStartState(stateMachine)
                    );
                    stateMachine.registerState(
                        "spin_result",
                        new MSSpinResultState(stateMachine)
                    );
                    stateMachine.registerState(
                        "spin_end",
                        new VOESpinEndState(stateMachine)
                    );
                    stateMachine.registerState(
                        "enter_freespins",
                        new MYSEnterFreespinsState(stateMachine)
                    );
                    stateMachine.registerState(
                        "lock_state",
                        new LockSymbolState(stateMachine)
                    );
                    stateMachine.registerState(
                        "show_win",
                        new VOEShowWinState(stateMachine)
                    );
                    stateMachine.registerState(
                        "big_win",
                        new VOEBigWinState(stateMachine)
                    );
                    stateMachine.registerState(
                        "loop_lines",
                        new LoopLinesState(stateMachine)
                    );
                    stateMachine.registerState(
                        "error",
                        new ErrorState(stateMachine)
                    );
                    // stateMachine.registerState("bonusReel", new PlayBonusReelState(stateMachine));
                    // stateMachine.registerState("exit_bonusReel", new RemoveBonusReelState(stateMachine));
                    stateMachine.registerState(
                        "reality_check",
                        new VendorRealityCheckState(stateMachine)
                    );
                    stateMachine.registerState(
                        "finish",
                        new MSFinishState(stateMachine)
                    );
                    stateMachine.registerState(
                        "fs_start",
                        new OkFStartFSState(stateMachine)
                    );
                    stateMachine.registerState(
                        "exit_freespins",
                        new SaSExitFreespinsState(stateMachine)
                    );
                    stateMachine.registerState(
                        "recover_spin",
                        new RecoverSpinStartState(stateMachine)
                    );
                    stateMachine.registerState(
                        "recover",
                        new EnterRecoverState(stateMachine)
                    );
                    stateMachine.registerState(
                        "freeGamesAward",
                        new FreeGamesAwardedState(stateMachine)
                    );
                    stateMachine.registerState(
                        "expand",
                        new SaSPlayAnimatedExpandState(stateMachine)
                    );
                    stateMachine.registerState(
                        "exitFreeGames",
                        new ExitFreeGamesState(stateMachine)
                    );

                    //** CONDITIONS **/
                    stateMachine.registerCondition(
                        "default",
                        new AlwaysTrueCondition()
                    );
                    stateMachine.registerCondition(
                        "hasBigWin",
                        new VOEHasBigWinCondition()
                    );
                    stateMachine.registerCondition(
                        "hasWin",
                        new VOEHasWinCondition()
                    );
                    stateMachine.registerCondition(
                        "hasAutoplay",
                        new HasAutoplayCondition()
                    );
                    stateMachine.registerCondition(
                        "freespinsWon",
                        new VOEFreeSpinsWonCondition()
                    );
                    stateMachine.registerCondition(
                        "inFreespins",
                        new IsInFreeSpinsCondition()
                    );
                    stateMachine.registerCondition(
                        "hasError",
                        new HasErrorCondition()
                    );
                    stateMachine.registerCondition(
                        "hasRealityCheck",
                        new HasRealityCheckCondition()
                    );
                    stateMachine.registerCondition(
                        "forceRealityCheck",
                        new ForceRealityCheckCondition()
                    );
                    stateMachine.registerCondition(
                        "hasRandom",
                        new CombinedCondition([
                            new IsInFreeSpinsCondition(),
                            new HasRandomSymbolsCondition()
                        ],ConditionCombinationType.ALL)
                    );
                    stateMachine.registerCondition(
                        "hasFreespins",
                        new HasFreeSpinsCondition()
                    );
                    stateMachine.registerCondition(
                        "hasExpand",
                        new HasExpandCondition()
                    );
                    stateMachine.registerCondition(
                        "hasLock",
                        new HasLockedCondition()
                    );
                    stateMachine.registerCondition(
                        "hasRecover",
                        new HasRecovery()
                    );
                    stateMachine.registerCondition(
                        "awardedFreeGames",
                        new AwardedFreeGamesCondition()
                    );
                    stateMachine.registerCondition(
                        "shouldExitFreeGames",
                        new ShouldExitFreeGamesCondition()
                    );
                    stateMachine.registerCondition(
                        "HasFreeGamesExpired",
                        new HasFreeGamesExpiredCondition()
                    );
                    stateMachine.registerCondition(
                        "hasFreeGamesRecover",
                        new CombinedCondition([
                            new AwardedFreeGamesCondition(),
                            new HasRecovery()
                        ],ConditionCombinationType.ALL)
                    );
                    stateMachine.startStateMachine(
                        state_config as IStatesConfigSchema
                    );
                }

                function initDefaultCommads() {
                    CommandManager.setCommand(
                        Commands.SPIN,
                        VendorCommands.SpinCommand
                    );
                    CommandManager.setCommand(
                        Commands.CLEAR_WIN,
                        GameCommands.ClearWinFieldCommand
                    );
                    CommandManager.setCommand(
                        Commands.SKIP,
                        GameCommands.SkipCommand
                    );
                    CommandManager.setCommand(
                        Commands.JACKPOT_ATTENDANCE,
                        GameCommands.JackpotAttendanceCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_SPACE_TO_SPIN,
                        GameCommands.ToggleSpaceToSpinCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_TURBO_SPIN,
                        VendorCommands.ToggleTuboSpinCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_SPACE_TURBO_SPIN,
                        GameCommands.ToggleSpaceTuboSpinCommand
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.TOGGLE_SKIP_INTRO,
                        VendorCommands.ToggleSkipIntroCommand
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.TOGGLE_SWIPE_TO_SPIN,
                        VendorCommands.ToggleSwipeToSpinCommand
                    );
                    CommandManager.setCommand(
                        Commands.START_AUTOPLAY,
                        VendorCommands.StartAutoplayCommand
                    );
                    CommandManager.setCommand(
                        Commands.STOP_AUTOPLAY,
                        VendorCommands.StopAutoplayCommand
                    );
                    CommandManager.setCommand(
                        Commands.DECREMENT_AUTOPLAY,
                        VendorCommands.DecrimentAutoplay
                    );
                    CommandManager.setCommand(
                        Commands.CLEAR_AUTOPLAY_LIMITS,
                        GameCommands.ClearAutoplayLimitsCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_AUTOPLAY_LOSS_LIMIT,
                        GameCommands.SetAutoplayLossLimitCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_AUTOPLAY_SINGLE_WIN_LIMIT,
                        GameCommands.SetAutoplaySingleWinLimitCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_AUTOPLAY_TOTAL_WIN_LIMIT,
                        GameCommands.SetAutoplayTotalWinLimitCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_AUTOPLAY_STOP_ON_ANY_WIN,
                        GameCommands.ToggleAutoplayStopOnWinCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_AUTOPLAY_STOP_ON_BIG_WIN,
                        GameCommands.ToggleAutoplayStopOnBigWinCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_AUTOPLAY_STOP_ON_FEATURE_WIN,
                        GameCommands.ToggleAutoplayStopOnFeatureCommand
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.SKIP_FREE_GAMES,
                        VendorCommands.SkipFreeSpins
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.CANCEL_FREE_GAMES,
                        VendorCommands.CancelFreeSpins
                    );
                    CommandManager.setCommand(
                        Commands.SHOW_ERROR,
                        GameCommands.ShowErrorPopup
                    );

                    CommandManager.setCommand(
                        Commands.CYCLE_STAKE_VALUE,
                        GameCommands.IterateStakeCommand
                    );
                    CommandManager.setCommand(
                        Commands.CYCLE_BET_VALUE,
                        GameCommands.IterateBetCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_MAX_BET,
                        GameCommands.SetMaxBetCommand
                    );
                    CommandManager.setCommand(
                        Commands.CYCLE_COIN_VALUE,
                        GameCommands.IterateCoinsCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_BET,
                        VendorCommands.SetBetCommand
                    );
                    CommandManager.setCommand(
                        Commands.CYCLE_TOTAL_BET,
                        GameCommands.IterateTotalBetCommand
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_BALANCE,
                        VendorCommands.makeBalanceRequest
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_WIN,
                        GameCommands.UpdateWinCommand
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_TEMP_WIN,
                        GameCommands.UpdateTempWinCommand
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_UI,
                        GameCommands.UpdateUICommand
                    );
                    CommandManager.setCommand(
                        Commands.UPDATE_FREE_SPINS,
                        GameCommands.UpdateFreeSpinsCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_SETTINGS,
                        VendorCommands.ToggleSettingsCommand
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.TOGGLE_GAME_INFO,
                        VendorCommands.ToggleGameInfoCommand
                    );
                    CommandManager.setCommand(
                        Commands.REQUEST_HISTORY,
                        VendorCommands.RequestHistory
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.GAME_PAUSED,
                        VendorCommands.ToggleGamePauseCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_PAYTABLE,
                        GameCommands.TogglePaytableCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_AUTOPLAY_POPUP,
                        MYSGameCommands.ToggleAutoplayPopupCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_BET_POPUP,
                        VendorCommands.ToggleBetPopupCommand
                    );
                    CommandManager.setCommand(
                        Commands.OPEN_RC_HISTORY,
                        VendorCommands.OpenRCHistory
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.TOGGLE_SOUND_CONTROLLER,
                        VendorCommands.ToggleSoundPopupCommand
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.TOGGLE_SOUND_BUTTON,
                        VendorCommands.ToggleSoundButtonCommand
                    );

                    CommandManager.setCommand(
                        Commands.TOGGLE_SOUND_FX,
                        GameCommands.ToggleSoundFXCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_MUSIC,
                        GameCommands.ToggleMusicCommand
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.UPDATE_JACKPOTS,
                        VendorCommands.UpdateJackpotsCommand
                    );
                    CommandManager.setCommand(
                        Commands.TOGGLE_MASTER_SOUND,
                        GameCommands.ToggleMasterSoundCommand
                    );
                    CommandManager.setCommand(
                        Commands.SAVE_SETTINGS,
                        GameCommands.SaveSettingsCommand
                    );
                    CommandManager.setCommand(
                        VendorCommandsEnum.TOGGLE_JACKPOTS_BUTTON,
                        VendorCommands.ToggleJackpotBtnCommand
                    );
                    CommandManager.setCommand(
                        Commands.SET_MASTER_VOLUME,
                        GameCommands.SetMasterVolumeCommand
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.SHOW_INSUFFICIENT_FUNDS_MESSAGE,
                        VendorCommands.ShowInsufficientFoundsDialog
                    );
                    CommandManager.setCommand(
                        Commands.GO_HOME,
                        VendorCommands.GoHome
                    );
                    CommandManager.setCommand(
                        Commands.CLOSE_SETTINGS,
                        GameCommands.CloseSettingsCommand
                    );

                    CommandManager.setCommand(
                        Commands.TOGGLE_BUY_FEATURE,
                        GameCommands.ShowBuyFeaturePopup
                    );

                    CommandManager.setCommand(
                        Commands.FEATURE_BUY_SPIN,
                        GameCommands.BuyFeatureSpin
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.FEATURE_BUTTON_OPTIONS,
                        MYSGameCommands.ShowBuyFeatureOptions
                    );

                    //----relax feim commands----
                    CommandManager.setCommand(
                        VendorCommandsEnum.INITIALIZE_API,
                        FeimCommands.initializeAPI
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.CONFIGURE,
                        FeimCommands.configure
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.GAME_LOAD_STARTED,
                        FeimCommands.gameLoadStarted
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.GAME_LOAD_PROGRESS,
                        FeimCommands.gameLoadProgress
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.GAME_LOAD_COMPLETED,
                        FeimCommands.gameLoadCompleted
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.BALANCE_UPDATE,
                        FeimCommands.balanceUpdate
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.AUTOPLAY_STARTED,
                        FeimCommands.autoPlayStarted
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.AUTOPLAY_FINISHED,
                        FeimCommands.autoPlayFinished
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.WIN_UPDATE,
                        FeimCommands.winUpdate
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.BET_UPDATE,
                        FeimCommands.betUpdate
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.DREAM_DROP_ENDED,
                        FeimCommands.dreamDropEnded
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.GAME_ROUND_STARTED,
                        FeimCommands.gameRoundStarted
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.GAME_ROUND_ENDED,
                        FeimCommands.gameRoundEnded
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.SEND_USER_ACTION,
                        FeimCommands.sendUserAction
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.SHOW_HISTORY,
                        FeimCommands.showHistory
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.FAST_PLAY_ACTIVATED,
                        FeimCommands.fastPlayActivated
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.FEATURE_STARTED,
                        FeimCommands.featureStarted
                    );

                    CommandManager.setCommand(
                        VendorCommandsEnum.FEATURE_FINISHED,
                        FeimCommands.featureFinished
                    );
                    //---------------------------

                    // TODO set the rest of them :)
                }

                function setUpUIComponents() {
                    UIController.setComponent("main", InstanceFactory.getClass("UIView"));
                    UIController.setComponent("settings", InstanceFactory.getClass("Settings"));
                    UIController.setComponent("autoplayPopup", new AutoplayPopup());
                    UIController.setComponent("autoplayLimitPopup", new VendorAutoplayLimitPopup());
                    UIController.setComponent("betPopup", new BetPopup());
                    // UIController.setComponent("soundPopup", new SoundPopup()); //* lemmy - Is it necessary to remove this?
                    UIController.setComponent("messagePopup", new MessagePopup());
                    UIController.setComponent("buyFeature", new BuyBonusPopups());
                    UIController.setComponent("buyFeatureSpin", new BuyFeatureSpinPopups());
                    UIController.setComponent("errorPopup", new VendorErrorPopup());
                }
            }
        );
    });

    // Populate requests
    // };
};
window.onload = () => {
    start({ config: game_config, gameFactory: new GameFactory() });
}
